/**
 * User Portal BFF
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MiningFppsRewardDetailsResponse { 
    calculationDate: string;
    avgHashrate: number;
    profitInUsd?: number | null;
    profitFpps: number;
}

